import { Outlet } from 'react-router-dom'
import Navbar from './Navbar'
import Footer from './Footer'

const Layout = () => {
  return (
    <div className="bg-gray-100 text-gray-800 relative min-h-screen">
      <Navbar />
      <Outlet />
      <Footer />
    </div>
  )
}

export default Layout